import throttle from 'lodash/throttle';

export default function ExitIntent(onExiting) {
    const defaultOptions = {
        cursorEventThrottle: 200,
        maxDisplays: 1,
        scrollEventThrottle: 500,
        scrollMinimumPercentConsumed: 0.5,
        threshold: 20,
    };

    return (function () {
        const config = defaultOptions;
        const eventListeners = new Map();

        let displays = 0;
        let lowestScrollPosition = 0;

        const addEvent = (eventName, callback) => {
            document.addEventListener(eventName, callback, false);
            eventListeners.set(`document:${eventName}`, { callback, eventName });
        };

        const removeEvent = (key) => {
            const { callback, eventName } = eventListeners.get(key);
            document.removeEventListener(eventName, callback);
            eventListeners.delete(key);
        };

        const shouldDisplayFromCursorEvent = (position) => {
            if (position <= config.threshold && displays < config.maxDisplays) {
                displays++;
                return true;
            }
            return false;
        };

        const shouldDisplayFromScrollEvent = (lowestPosition, currPosition, totalHeight) => {
            // if the user has scrolled up more than 10% of the total page height,
            // AFTER scrolling past our threshhold % of content, they're probably on their way out
            const lowestScrollHeightTheshhold = totalHeight * config.scrollMinimumPercentConsumed;
            if (
                lowestScrollPosition > lowestScrollHeightTheshhold &&
                lowestPosition - currPosition > totalHeight / 10
            ) {
                displays++;
                return true;
            }
            return false;
        };

        const mouseDidMove = (event) => {
            if (shouldDisplayFromCursorEvent(event.clientY)) {
                onExiting(true);
                if (displays >= config.maxDisplays) {
                    removeEvents();
                }
            }
        };

        const scrolled = (event) => {
            const scrollHeight = event.srcElement.documentElement.scrollHeight;
            const currPosition = event.srcElement.documentElement.scrollTop;
            lowestScrollPosition = currPosition > lowestScrollPosition ? currPosition : lowestScrollPosition;
            if (shouldDisplayFromScrollEvent(lowestScrollPosition, currPosition, scrollHeight)) {
                onExiting(true);
                if (displays >= config.maxDisplays) {
                    removeEvents();
                }
            }
        };

        const removeEvents = () => {
            eventListeners.forEach((value, key) => removeEvent(key));
        };

        addEvent('mousemove', throttle(mouseDidMove, config.cursorEventThrottle));
        addEvent('scroll', throttle(scrolled, config.scrollEventThrottle));

        return removeEvents;
    })();
}
